import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Stack {
  constructor(element) {
	 this.container = element;
    this.stackElements = Array.from(element.querySelectorAll('.js-stack-element'));

    this.init();
  }

  init() {
	this.stackElements.forEach((stackElement, i) => {

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: stackElement,
			start: "top top",
			pinSpacing: false,
			pin: true,
			scrub: true,
		}
	});

	tl
		.fromTo(
			stackElement,
			{ scale: 1,
			  opacity: 1
			},
			{ scale: .9,
			  opacity: .6
			},
		)
		.set(
			stackElement,
			{ autoAlpha: 0 }
		);
	});
  }
}
